export class RankedDivisionState {
    static deserialize(data) {
        return new RankedDivisionState(data.divisionType, data.subdivisionType, data.demotionDivisionBoundary, data.promotionDivisionBoundary);
    }
    constructor(divisionType, subDivision, demotionDivisionBoundary, promotionDivisionBoundary){
        this.divisionType = divisionType;
        this.subdivisionType = subDivision;
        this.demotionDivisionBoundary = demotionDivisionBoundary;
        this.promotionDivisionBoundary = promotionDivisionBoundary;
    }
}
